<template>
  <el-table
    :data="appraises"
    border
    style="width: 100%"
    class="table"
  >
    <el-table-column
      prop="servName"
      :label="$t('servAppraiseManage.table.servName')"
      align="center"
    />
    <el-table-column
      prop="appraiseUserName"
      :label="$t('servAppraiseManage.table.appraiseUserName')"
      align="center"
    />
    <el-table-column
      prop="appraiseScore"
      :label="$t('servAppraiseManage.table.appraiseScore')"
      align="center"
    />
    <el-table-column
      prop="context"
      :label="$t('servAppraiseManage.table.context')"
      align="center"
    />
    <el-table-column
      prop="imgPath"
      :label="$t('servAppraiseManage.table.imgPath')"
      align="center"
    />
    <el-table-column
      prop="createTime"
      :label="$t('servAppraiseManage.table.createTime')"
      align="center"
    />
    <el-table-column
      :label="$t('servAppraiseManage.table.operation')"
      align="center"
    >
      <template slot-scope="scope">
        <el-button
          size="mini"
          class="btn-white"
          @click="handleAckAppraise(scope.row)"
        >
          {{ $t('servAppraiseManage.table.replyBtn') }}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'ServAppraiseManageTable',
  props: {
    appraises: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    handleAckAppraise(row) {
      this.$emit('ack-appraise', row)
    }
  }
}
</script>

<style scoped>
.btn-white {
  background: #fff;
  color: #333;
  border: 1px solid #dcdfe6;
}
.table {
  margin-bottom: 20px;
}
</style>